import React from 'react';
import PropTypes from 'prop-types';
import styles from './SignupThankYou.module.scss';

// What the entry screen becomes once a parent has signed up.
//
// REPLACES THE CARD rather than adding a line to it. A confirmation tucked
// under a form the parent has already finished with leaves them looking at the
// same controls, unsure whether anything happened; swapping the card out is
// unambiguous.
//
// The one action offered is signing up another child, because a parent with two
// at the same school is the ordinary case and would otherwise have to find
// their way back to a form that no longer exists.
const STRINGS = {
  en: {
    title: 'Thank you',
    body: 'We’ll notify you as soon as your photos are ready to view',
    another: 'Sign up another student',
  },
  es: {
    title: 'Gracias',
    body: 'Le avisaremos en cuanto sus fotos estén listas para ver',
    another: 'Registrar otro estudiante',
  },
};

const SignupThankYou = ({ lang, onAnother }) => {
  const t = STRINGS[lang] || STRINGS.en;

  return (
    <div className={styles.thanks} role="status">
      <h1 className={styles.title}>{t.title}</h1>
      <p className={styles.body}>{t.body}</p>

      {onAnother && (
        <button type="button" className={styles.another} onClick={onAnother}>
          {t.another}
        </button>
      )}
    </div>
  );
};

SignupThankYou.propTypes = {
  lang: PropTypes.string,
  onAnother: PropTypes.func,
};

SignupThankYou.defaultProps = { lang: 'en', onAnother: null };

export default SignupThankYou;
